import { configureStore } from '@reduxjs/toolkit'

// Core
import reducers from './reducers';

const store = configureStore({ reducer: reducers });

export default store;